import { AvailableAccommodations } from '@/app/pages/accommodations/available-accommodations';
import { createFileRoute } from '@tanstack/react-router';

import { accommodationSearchSchema } from '@/features/accommodation/config/accommodation-filters';

export const Route = createFileRoute('/available-accommodations/')({
  validateSearch: accommodationSearchSchema,
  component: AvailableAccommodations,
});
